import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import openWithApp from '../../utils/openWithApp';
import ErrorContent from '../../components/ErrorContent';
import ErrorTypes from '../../constants/ErrorTypes';
import { iosInstallUrl, androidInstallUrl } from '../../constants/Urls';
import tiaraClickSender from '../../utils/tiaraClickSender';

class ProfileChatPage extends Component {
  constructor(props) {
    super(props);
    this.handleOpenWithApp = this.handleOpenWithApp.bind(this);
    this.handleOpenInstallPage = this.handleOpenInstallPage.bind(this);
    this.getCustomUrl = this.getCustomUrl.bind(this);
  }

  componentDidMount() {
    const { device, profile } = this.props;
    if (device.getIn(['device', 'type']) === 'mobile') {
      this.handleOpenWithApp();
    }
  }

  getCustomUrl(profile, referer) {
    const customUrl = `plusfriend/talk/chat/${profile.get('uuid')}`;
    if (referer) {
      return `${customUrl}?extra=${encodeURIComponent(JSON.stringify({ referer }))}`;
    }
    return customUrl;
  }

  handleOpenWithApp() {
    const { device, profile, error, referer } = this.props;
    if (error.size === 0) {
      const customUrl = this.getCustomUrl(profile, referer);
      openWithApp(
        device.getIn(['os', 'name']),
        process.env.REACT_APP_PF_CUSTOM_SCHEME,
        customUrl,
        'com.kakao.talk',
        'https://itunes.apple.com/kr/app/kakaotog-kakaotalk/id362057947'
      );
    }
  }

  handleOpenInstallPage() {
    const { device } = this.props;
    window.open(device.getIn(['os', 'name']) === 'iOS' ? iosInstallUrl : androidInstallUrl)
  }

  render() {
    const { device, profile, error } = this.props;

    return (
      <div style={{ height: '100%' }}>
				<div id="kakaoWrap">
					<div id="kakaoHead" className="head_bridge" role="banner">
						<h1 className="tit_logo">
							<a href="#none" className="link_logo" style={{ padding: 0 }}>
                <span className="ico_plus ico_logo">카카오톡 채널</span>
              </a>
						</h1>
					</div>
					<hr className="hide" />
          {/* 톡연동 : .cont_inter */}
          {error.size !== 0
            ? <ErrorContent error={error} device={device} profile={profile} />
            : (
              <div id="kakaoContent" className="cont_bridge cont_inter" role="main">
                <span className="img_bridge" />
                <strong className="tit_bridge">카카오톡으로 채팅을 시작합니다.</strong>
                <p className="desc_bridge">Mobile / pc 카카오톡으로 상담 시작을 알리는<br />메시지가 발송되었으니 확인해 주세요.</p>
                <p className="desc_bridge desc_inter">카카오톡이 설치되지 않았거나,<br />최신 버전이 아닌 경우 채팅이 지원되지 않습니다.</p>
                <a href="#none" className="btn_talk btn_type1 install_talk_app" onClick={this.handleOpenInstallPage}
                  data-tiara-layer="talk_install"
                >
                  카카오톡 최신 버전 설치하기
                </a>
                <a href="#none" className="btn_talk btn_type2 open_talk_app" onClick={this.handleOpenWithApp}
                  data-tiara-layer="talk_launch"
                >
                  카카오톡에서 시작하기
                </a>
                <div className="logout_bridge">
                  <a href={`${process.env.REACT_APP_KAKAO_ACCOUNT_URL}/logout?continue=${process.env.REACT_APP_SERVICE_HOST}/logged_out`}
                    className="btn_bridge link_bridge link_type2 logout" data-tiara-layer="logout"
                  >
                    로그아웃
                  </a>
                </div>
              </div>
            )
          }
				</div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { device, error, referer } = state;
  const profile = state.profile;
  const refererStr = (typeof referer === 'string')? referer : undefined;
  return { device, profile, error, referer: refererStr, ...ownProps };
};

export default connect(mapStateToProps)(tiaraClickSender(ProfileChatPage));



// WEBPACK FOOTER //
// ./src/containers/ProfileChatPage/index.js